const html = require('choo/html');
const L = require('leaflet');
const Component = require('choo/component');
const d3 = require('d3-scale');

module.exports = class Map extends Component {
  constructor(id, state, emit) {
    super(id);
    this.local = state.components[id] = {};
    // console.log(state);
  }

  load(element) {
    /*
    [43.052, 86.212]
    nyc - [40.735707, -73.990963]
    */
    this.map = L.map(element, this.mapOpts).setView(
      [40.735707, -73.990963],
      10
    );

    /*
      ESRI World Imagery https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}
      CartoDB https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png
      OpenTopo https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png
      local /public/osm-tiles/{z}/{x}/{y}.png
    */
    L.tileLayer(
      'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
      {
        attribution:
          'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 18
      }
    ).addTo(this.map);
  }

  getLocationColor(location, highlight) {
    if (highlight && location[highlight.key] === highlight.id) {
      return 'blue';
    } else if (
      location.tri_facility_id === '77507HCHST9502B' ||
      location.tri_facility_id === '23231STRLZ5674E' ||
      location.tri_facility_id === '77651TXCCHHWY36'
    ) {
      return 'yellow';
    } else if (location.tri_revision_amount !== 0) {
      return 'red';
    } else {
      return 'green';
    }
  }

  clearLocations() {
    this.local.locations.map((l) => {
      l.remove ? l.remove() : '';
    });
  }

  update(locations, highlight, facilityClick, _, markerOpts = {}) {
    const radiusKey = 'tri_avg_reported_2014_2019';

    if (this.local.locations) {
      this.clearLocations();
    }

    let highlightLatLng;

    const radius = d3
      .scaleLinear()
      // locations[locations.length - 1][radiusKey],
      .domain([0, locations[0][radiusKey]])
      .range([1500, 50000]);

    this.local.locations = locations
      // .slice(0, 1)
      .filter((l) => (l.lat && l.lng) || l.latlngs)
      .map((location) => {
        if (highlight && location[highlight.key] === highlight.id) {
          highlightLatLng = location.latlngs
            ? location.latlngs
            : [location.lat, location.lng];
        }
        // console.log(location[radiusKey], radius(location[radiusKey]));
        const color = this.getLocationColor(location, highlight);

        const marker = L.circle(
          [location.lat, location.lng],
          Object.assign(
            {
              color,
              fillColor: color,
              fillOpacity: 0.5,
              opacity: 0.5,
              radius:
                location[radiusKey] === 0 ? '100' : radius(location[radiusKey])
            },
            markerOpts
          )
        );

        if (facilityClick) {
          marker.on('click', (evt) => {
            // console.log(JSON.stringify(location, null, ' '));
            facilityClick(location.tri_facility_id, evt.originalEvent);
          });
        }

        //         marker.bindPopup(`<pre>
        // ${JSON.stringify(location, null, ' ')}
        // </pre>`);

        marker.addTo(this.map);
        return marker;
      });

    if (highlight) {
      //zoom and center on location.
      // this.map.flyTo(highlightLatLng, 10);
      this.map.setView(highlightLatLng, 9, {
        duration: 0.25,
        animate: true
      });
    } else {
      const featureGroup = L.featureGroup(this.local.locations);
      this.map.fitBounds(featureGroup.getBounds());
      this.map.setZoom(4, {
        duration: 0.25,
        animate: true
      });
    }

    return false;
  }

  createElement(locations, highlight, locationClick, mapOpts = {}) {
    this.local.locations = locations;
    this.mapOpts = mapOpts;
    return html` <div class="h-100"></div> `;
  }
};
